export default {"src":"/_next/static/media/barcode-without-scanner.71c3df98.svg","height":568,"width":568,"blurWidth":0,"blurHeight":0};